import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';
import useGetProfile from './useGetProfile';

export default function useGetUserReports(
  accountUserId?: string,
  enable?: boolean,
) {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');
  const { data: profile } = useGetProfile();

  return useQuery({
    queryKey: ['REPORTS', accountUserId],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/reports/user/${accountUserId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: isAuthenticated && !!token && !!accountUserId && enable,
  });
}
